<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('provisional.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('provisional.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('provisional.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('provisional.branchName')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('provisional.mainProgram')
                      }}</label>
                      <treeselect
                        :options="main_programs"
                        :placeholder="$t('report.all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.acp_id"
                        @input="onMainProgramChange"
                        :maxHeight="150"
                      ></treeselect>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('provisional.subProgram')
                      }}</label>
                      <ts-loading-banner :loading="fetching">
                        <treeselect
                          :options="sub_programs"
                          :placeholder="$t('report.all')"
                          :multiple="true"
                          :limit="1"
                          v-model="model.acps_id"
                          :maxHeight="150"
                        ></treeselect>
                      </ts-loading-banner>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('provisional.studentName') }}</label>
                      <treeselect
                        :options="
                          students.map(i => ({
                            id: i.student_id,
                            label: i.full_name_en
                          }))
                        "
                        :placeholder="$t('report.all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.student_id"
                      ></treeselect>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('provisional.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import TsLoadingBanner from '../../../components/common/TsLoadingBanner.vue'

export default {
  components: { TsLoadingBanner },
  name: 'provisional',
  data () {
    return {
      loading: false,
      waiting: false,
      fetching: false,
      src: '',
      errors: new Errors(),
      branches: [],
      main_programs: [],
      sub_programs: [],
      model: {
        branch_id: null,
        acp_id: [],
        acps_id: [],
        student_id: null
      }
    }
  },
  computed: {
    students () {
      return this.$store.state.reportAcademic.students
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'getBranch',
      'getMainProgram',
      'getSubProgram',
      'provisional',
      'getStudent'
    ]),
    async fetchData () {
      this.loading = true
      await this.getStudent()
      await this.getMainProgram().then(response => {
        this.main_programs = response.data.map(el => ({
          id: el.acp_id,
          label: el.acp_name_foreign
        }))
      })
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = this.$store.state.authUser.default_branch_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onMainProgramChange () {
      this.model.acps_id = []
      this.fetching = true
      if (this.model.acp_id.length <= 0) {
        this.fetching = false
        return
      }
      this.getSubProgram({
        filter: {
          acp_id: this.model.acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            id: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    preview () {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.provisional(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
